import Lara from "@/presets/lara";

export const priceOverridePresets = {
  ...Lara,
  inputtext: {
    ...Lara.inputtext,
    root: (args) => {
      return { class: ["!rounded-full", ...Lara.inputtext.root(args).class] };
    },
  },
};
